<template>
    <div class="rubrics-nav" id="rubricNav" style="display: block; opacity: 1;">
        <div class="content-wrapper">
            <ul class="rubrics-nav__list">
                <li><a href="#" role="button" class="active">{{$t('all')}}</a></li>
                <li v-for="item in menu" :key="item.id"><a :href="'#' + item.route" role="button">{{item.title}}</a></li>
            </ul>
        </div>
    </div>
</template>

<script>
    import { scrollToAnchor } from '../outer-js'
    export default {
        name: "PageMenu",
        props:['menu'],
        mounted(){
            scrollToAnchor()
        },
    }
</script>

<style scoped>

</style>